import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MappingService {

  constructor() {
  }

  getMappedCurrency(currencyMappings: any, ccy: string, exchangeName: string): string {
    const mappedCcy = currencyMappings[exchangeName.toLowerCase()][ccy];
    return mappedCcy ? mappedCcy : ccy;
  }

  getInvertedMappedCurrency(currencyMappings: any, ccy: string, exchangeName: string): string {
    let mappedCcy = null;
    Object.keys(currencyMappings[exchangeName.toLowerCase()]).forEach(item => {
      if (currencyMappings[exchangeName.toLowerCase()][item] === ccy) {
        mappedCcy = item;
      }
    });
    return mappedCcy ? mappedCcy : ccy;
  }
}
